var _rect, _rect2, _rect3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _path, _path2, _path3, _rect4, _rect5, _rect6, _path4, _path5, _circle, _ellipse, _ellipse2, _ellipse3, _rect7, _line8, _line9, _rect8, _line10, _line11, _rect9, _circle2, _rect10, _path6, _rect11, _rect12, _path7, _path8, _line12, _line13, _circle3, _circle4, _circle5, _circle6, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunnySnail2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "#E8F8F5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 240,
    fill: "#D0ECE7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 240,
    width: 400,
    height: 60,
    fill: "#CBA372"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 250,
    x2: 400,
    y2: 250,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 270,
    x2: 400,
    y2: 270,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 290,
    x2: 400,
    y2: 290,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 240,
    x2: 50,
    y2: 300,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: 240,
    x2: 150,
    y2: 300,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 240,
    x2: 250,
    y2: 300,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 240,
    x2: 350,
    y2: 300,
    stroke: "#B08B5A",
    strokeWidth: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M330,240 L350,240 L345,200 L335,200 Z",
    fill: "#D2B4DE",
    stroke: "#A569BD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M330,200 L350,200",
    stroke: "#A569BD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M335,190 C335,185 345,185 345,190",
    stroke: "#A569BD",
    strokeWidth: 2,
    fill: "none"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 215,
    width: 40,
    height: 5,
    fill: "#D2B4DE",
    stroke: "#A569BD",
    strokeWidth: 1
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 220,
    width: 40,
    height: 10,
    fill: "#7D3C98",
    stroke: "#A569BD",
    strokeWidth: 1
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 217,
    width: 40,
    height: 7,
    fill: "#A04000",
    stroke: "#6E2C00",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C110,220 170,220 220,220 C270,220 300,230 300,230 L300,260 C240,255 180,255 120,255 C60,255 50,260 50,260 Z",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50,230 C40,210 50,190 70,190 C90,190 100,210 90,230",
    fill: "#FDEBD0",
    stroke: "#F39C12",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 170,
    r: 70,
    fill: "#E67E22",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 50,
    ry: 40,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 3
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 35,
    ry: 28,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180,
    cy: 170,
    rx: 20,
    ry: 16,
    fill: "none",
    stroke: "#A04000",
    strokeWidth: 2
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 150,
    width: 15,
    height: 15,
    fill: "#AED6F1",
    stroke: "#A04000",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 158,
    x2: 215,
    y2: 158,
    stroke: "#A04000",
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 207,
    y1: 150,
    x2: 207,
    y2: 165,
    stroke: "#A04000",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 180,
    width: 15,
    height: 15,
    fill: "#AED6F1",
    stroke: "#A04000",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 188,
    x2: 245,
    y2: 188,
    stroke: "#A04000",
    strokeWidth: 1
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 237,
    y1: 180,
    x2: 237,
    y2: 195,
    stroke: "#A04000",
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 195,
    width: 15,
    height: 25,
    fill: "#8E44AD",
    stroke: "#A04000",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 173,
    cy: 207,
    r: 2,
    fill: "#F1C40F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 130,
    width: 10,
    height: 20,
    fill: "#6E2C00",
    stroke: "#A04000",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M130,235 C160,232 190,232 220,235",
    stroke: "#6E2C00",
    strokeWidth: 5,
    fill: "none"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 232,
    width: 10,
    height: 7,
    fill: "#F1C40F",
    stroke: "#6E2C00",
    strokeWidth: 1
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 232,
    width: 10,
    height: 7,
    fill: "#F1C40F",
    stroke: "#6E2C00",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55,135 C55,130 65,125 75,125 C85,125 95,130 95,135",
    fill: "#F1C40F",
    stroke: "#E67E22",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50,140 C50,135 55,135 55,135 L95,135 C95,135 100,135 100,140 L97,145 L53,145 Z",
    fill: "#F1C40F",
    stroke: "#E67E22",
    strokeWidth: 2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 190,
    x2: 60,
    y2: 155,
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: 190,
    x2: 80,
    y2: 155,
    stroke: "#F39C12",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 155,
    r: 8,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 155,
    r: 8,
    fill: "white",
    stroke: "#000",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 155,
    r: 4,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 155,
    r: 4,
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M60,215 C65,220 75,220 80,215",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnySnail2);
export default __webpack_public_path__ + "static/media/funny-snail2.6418b04f199f9b2fdc00a601368ec30f.svg";
export { ForwardRef as ReactComponent };